import React, { useEffect, useRef, useState } from 'react';
import { useData } from '../../../../contexts';
import { AccordionThema } from './AccordionThema';
import Grid from '@mui/material/Grid';
import { Box } from '@mui/system';
import { MdClose, MdFilterAltOff } from 'react-icons/md';
import { Menu, MenuItem } from 'react-pro-sidebar';
import { Modal } from '@mui/base';
import { Backdrop } from '@mui/material';
import { DropdownGemeenteBench } from './DropdownGemeenteBench';

export const SelectionPanel = (props: any) => {
  const {
    themas,
    indicatorThema,
    gemeenteLijst,
    selectedGemeente,
    selectedBenchmarks,
    benchmarkLijst,
    open,
    setOpen,
    d_ruimte,
    isMobile,
  } = props;

  const {
    interfaceColor,
    setSelectedGemeente,
    setSelectedBenchmarks,
    setSelectedIndicatorsInzichten,
    globalSourceFilter,
    setGlobalSourceFilter,
    showTable,
    setZoomFilters,
  } = useData();

  const handleClose = () => setOpen(false);
  const handleToepassen = () => {
    const selGem = getSelGem();
    const selBench = getSelBench();
    const selInd = getSelInd();
    const selSource = getSelSource();

    if (selInd[0] !== -1) {
      setSelectedGemeente(selGem);
      setSelectedBenchmarks(selBench);
      setGlobalSourceFilter(selSource);
      setSelectedIndicatorsInzichten(selInd);
      setOpen(false);
      setZoomFilters({});
    } else {
      alert('Gelieve één of meerdere indicatoren te selecteren');
    }
  };

  // const selGemRef = useRef();
  // const selBenchRef = useRef();
  const selGemBenchRef = useRef();
  const selIndRef = useRef();

  const getSelGem = () => {
    const selGem: any = selGemBenchRef.current.getSelGem();
    return selGem;
  };

  const getSelBench = () => {
    const selBench: any = selGemBenchRef.current.getSelBench();
    return selBench;
  };

  const getSelInd = () => {
    const selInd: any = selIndRef.current.getSelInd();
    const indicators = selInd.filter((d: any) => {
      return d.checked === true;
    });

    indicators.sort((a: any, b: any) => {
      if (!(a && a.indicator && b && b.indicator)) return;

      const stringA = a.indicator.toUpperCase(); // ignore upper and lowercase
      const stringB = b.indicator.toUpperCase(); // ignore upper and lowercase
      if (stringA > stringB) return 1;
      if (stringA < stringB) return -1;
      return 0;
    });

    if (showTable) {
      indicators.sort((a: any, b: any) => {
        return parseInt(b?.isSurvey) - parseInt(a?.isSurvey);
      });
    }

    const unique = [...new Set(indicators.map((d: any) => d.idIndicator))];
    const out = unique.length === 0 ? [-1] : unique;
    return out;
  };

  const getSelSource = () => {
    const selSource: any = selIndRef.current.getSelSource();
    return selSource;
  };

  return (
    <>
      {themas && themas.length > 0 && (
        <Modal
          open={open}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          slots={{ backdrop: Backdrop, baseTooltip: null }}
          slotProps={{
            backdrop: {
              style: {
                zIndex: 101,
                backgroundColor: 'rgba(0, 0, 0, 0.2)',
              },
            },
          }}
        >
          <Box
            sx={{
              fontSize: isMobile ? '13px' : '16px',
              position: 'fixed',
              top: '0%',
              left: '50%',
              transform: isMobile
                ? 'translate(-50%, 0)'
                : 'translate(-50%, 10%)',
              maxWidth: 1000,
              maxHeight: isMobile ? '100%' : '85%',
              height: isMobile ? '100%' : '85%',
              width: '100%',
              bgcolor: 'background.paper',
              border: '2px solid #000',
              p: 4,
              overflowY: 'auto',
              zIndex: 102,
              marginBottom: '100px',
            }}
            className={'vl-typography'}
            id="selectionScreenBox"
          >
            <Grid container>
              <Grid item xs={12}>
                <p style={{ marginBottom: '48px' }}>
                  <i>
                    Wat zijn sterke punten en aandachtspunten van je gemeente,
                    zowel ten opzichte van een gekozen benchmark als doorheen de
                    tijd? Duik in de grafieken op deze pagina en krijg meer
                    inzicht in je gemeente, onder meer door een rangschikking
                    van gemeenten per indicator.
                  </i>
                </p>
                <h2
                  style={{
                    paddingTop: isMobile ? 10 : 0,
                    fontSize: isMobile ? 14 : 18,
                    width: isMobile ? '120px' : '300px',
                    float: 'left',
                    margin: 0,
                  }}
                >
                  Pas je selecties aan
                </h2>

                <button
                  onClick={handleClose}
                  style={{
                    color: interfaceColor,
                    width: '30px',
                    float: 'right',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    cursor: 'pointer',
                    marginLeft: '12px',
                    position: 'relative',
                    top: '4px',
                    right: '0px',
                    fontSize: '24px',
                    border: 'none',
                  }}
                >
                  <span className="vl-button__label">
                    <MdClose />
                  </span>
                </button>

                <button
                  onClick={handleToepassen}
                  className="vl-button"
                  vl-button
                  style={{
                    backgroundColor: interfaceColor,
                    fontSize: isMobile ? '13px' : '16px',
                    width: isMobile ? '100px' : '140px',
                    float: 'right',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <span className="vl-button__label">Toepassen</span>
                </button>

                <p style={{ clear: 'both', paddingTop: isMobile ? 8 : 0 }}>
                  Selecteer eerst je gemeente en een benchmark.
                  <br />
                  Kies vervolgens één of meerdere thema's en indicatoren.
                </p>
                <Menu
                  style={{
                    paddingTop: '24px',
                  }}
                  menuItemStyles={{
                    button: ({ level, active, disabled }) => {
                      return {
                        paddingLeft: isMobile ? '0' : '24px',
                        paddingRight: isMobile ? '0' : '24px',
                        listStyleType: 'none',
                        height: '70px',
                      };
                    },
                  }}
                >
                  <DropdownGemeenteBench
                    gemeenteLijst={gemeenteLijst}
                    selectedGemeente={selectedGemeente}
                    benchmarkLijst={benchmarkLijst}
                    selectedBenchmarks={selectedBenchmarks}
                    interfaceColor={interfaceColor}
                    d_ruimte={d_ruimte}
                    ref={selGemBenchRef}
                  />
                  {/* <DropdownGemeente
                    gemeenteLijst={gemeenteLijst}
                    selectedGemeente={selectedGemeente}
                    ref={selGemRef}
                  />
                  <DropdownBenchmarks
                    benchmarkLijst={benchmarkLijst}
                    selectedBenchmarks={selectedBenchmarks}
                    interfaceColor={interfaceColor}
                    ref={selBenchRef}
                  /> */}

                  <AccordionThema
                    themas={themas}
                    indicatorThema={indicatorThema}
                    globalSourceFilter={globalSourceFilter}
                    ref={selIndRef}
                    isMobile={isMobile}
                  />

                  <MenuItem>
                    <button
                      onClick={handleToepassen}
                      className="vl-button"
                      vl-button
                      style={{
                        backgroundColor: interfaceColor,
                        float: 'right',
                        marginRight: '20px',
                        width: '140px',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: isMobile ? '12px' : '15px',
                      }}
                    >
                      <span className="vl-button__label">Toepassen</span>
                    </button>

                    <button
                      onClick={handleClose}
                      className="vl-button"
                      vl-button
                      style={{
                        backgroundColor: 'transparent',
                        color: interfaceColor,
                        marginRight: '20px',
                        float: 'right',
                        border: `1px solid ${interfaceColor}`,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        fontSize: isMobile ? '12px' : '15px',
                      }}
                    >
                      <span className="vl-button__label">Annuleren</span>
                    </button>
                  </MenuItem>
                </Menu>
              </Grid>
            </Grid>
          </Box>
        </Modal>
      )}
    </>
  );
};
